exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-702b3522] {\n  margin-top: 16px;\n}\n.logout[data-v-702b3522] {\n  font-size: 14px;\n  display: block;\n  color: black;\n  text-decoration: none;\n}", ""]);

// exports
